import { request, METHOD } from '../utils/request.js'

// 查询学生人脸状态和作业状态
// 入参snCode,termCode
// 返参faceStatus(0,无人脸,1,有人脸)
// homeStatus(0,无作业任务,1,已提交,2,未提交)
export function getStudentStatus(data) {
  return request(
    'h5Mfitness/newH5Fitness/getStudentStatus',
    METHOD.POST,
    data
  )
}
// 积分
export function selectSportsPoints(data) {
  return request(
    'h5Mfitness/newH5Fitness/selectSportsPoints',
    METHOD.POST,
    data
  )
}
// 积分获取
export function saveSportsPoints(data) {
  return request(
    'h5Mfitness/newH5Fitness/saveSportsPoints',
    METHOD.POST,
    data
  )
}

// 测试记录
export function selectStudentActivityList(data) {
  return request(
    'h5Mfitness/newH5Fitness/selectStudentActivityList',
    METHOD.POST,
    data
  )
}

// 查看7日测试次数,班级平均次数,锻炼前5项目
export function selectActivityBySevenDay(data) {
  return request(
    'h5Mfitness/newH5Fitness/selectActivityBySevenDay',
    METHOD.POST,
    data
  )
}
// 查看总分数据
export function selectAllScoreNewFitness(data) {
  return request(
    'h5Mfitness/newH5Fitness/selectAllScoreNewFitness',
    METHOD.POST,
    data
  )
}

// 查看月份测试情况数据
export function selectMonthStatusNewFitness(data) {
  return request(
    'h5Mfitness/newH5Fitness/selectMonthStatusNewFitness',
    METHOD.POST,
    data
  )
}

// 每日,运动班级和年级排行
export function selectDayTopNewFitness(data) {
  return request(
    '/h5Mfitness/newH5Fitness/selectDayTopNewFitness',
    METHOD.POST,
    data
  )
}

export function selectBodyProjectRel(data) {
  return request(
    '/h5Mfitness/newH5Fitness/selectBodyProjectRel',
    METHOD.POST,
    data
  )
}